(function() {
  'use strict';

  angular
    .module('admin.users.details.showcases', [])
    .controller('ShowcasesAdminCtrl', ShowcasesAdminCtrl);

  /** @ngInject */
  function ShowcasesAdminCtrl($scope, $stateParams, $rootScope, UsersService) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;
    vm.usersPerPage = 25;

    function reloadPagination(){
      vm.totalUsers = 0;
      vm.oldPage = 0;
      vm.currentPage = 25;
      vm.first = true;
      vm.totalItems = 0;
      vm.pagination = {
        current: 1
      };
    }

    reloadPagination();
    load(1);

    function load(pageNumber){
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }

      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      }
      else {
        vm.first = false;
      }

      UsersService.listShowcases($stateParams.parentId, vm.oldPage, 25).then(success);

      function success(result){
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }
        for (var i = 0; i < result.results.length; i++) {
          result.results[i].ts = new Date(parseInt(result.results[i].ts.toString().substring(0, result.results[i].ts.toString().length - 3)));
        }
        vm.items = result.results;
      }
    }

    vm.pageChanged = function(newPage) {
      load(newPage);
    };

    vm.delete = function(item){
      var html = '<div><img src="' + $rootScope.urlS3 +'/users/'+item.img+'" class="avatar avatar-original" style="-webkit-user-select:none; width: 158px; height: 158px;"><br><h2>Remove showcase</h2><h4>Are you sure?</h4></div>';

      swal({
        title: "",
        type: "",
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: "slide-from-top",
        text: html,
        html: true
      }, function(isConfirm){
          if (isConfirm){
            UsersService.deleteShowcase(item.id).then(function(){
              reloadPagination();
              load(vm.pagination.current);
            }, function(err){
              swal(err.error.message, '', 'error');
            });
          } else {
            return;
          }
      });
    };
  }

})();
